var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].indexOf(_vm.suffix) > -1)?_c('ct-preview-image',{ref:"previewPlugin",attrs:{"image-info":JSON.stringify([_vm.file])}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }